import React from "react";
import mock01 from '../assets/images/NYC Taxi Data Engineering Plateform.png';
import mock02 from '../assets/images/Hybrid Data Lakehouse Architecture Diagram.png';
import mock03 from '../assets/images/data_architecture.png';
import mock04 from '../assets/images/Project Architecture.png';
import mock05 from '../assets/images/Cdiscount_analysis.png';
import mock06 from '../assets/images/123456.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/modern-data-stack-nyc-taxi" target="_blank" rel="noreferrer"><img src={mock01} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/modern-data-stack-nyc-taxi" target="_blank" rel="noreferrer"><h2>Modern Data Stack : NYC Taxi</h2></a>
                <p>This project simulates a real-world data platform for a Taxi company. It ingests high-volume trip data, cleanses it, models it into a Star Schema, and serves it to different stakeholders (Executives, Operations, Finance) via Dashboards and APIs.</p>
            </div>

            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/sales-analytics-data-lakehouse" target="_blank" rel="noreferrer"><img src={mock02} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/sales-analytics-data-lakehouse" target="_blank" rel="noreferrer"><h2>Sales Analytics Data Lakehouse</h2></a>
                <p>This project simulates a real-world enterprise data migration and modernization strategy. It extracts transactional data from a simulated "On-Premise" environment (hosted on AWS EC2), performs heavy distributed processing using a Hadoop/Spark cluster, and ultimately serves the data via a Cloud-Native, serverless architecture to optimize costs (FinOps).</p>
            </div>

            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/datawarehouse_erp_crm" target="_blank" rel="noreferrer"><img src={mock03} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/datawarehouse_erp_crm" target="_blank" rel="noreferrer"><h2>ERP & CRM Data Warehouse</h2></a>
                <p>This project demonstrates a Data Warehouse implementation designed following the Medallion Architecture (Bronze, Silver, and Gold layers).
                    It is executed entirely within Microsoft SQL Server using T-SQL scripts. The goal of this project is to demonstrate proficiency in SQL, and the basic idea of Data Warehousing concept.</p>
            </div>

            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/uk_onlineretail-dataeng" target="_blank" rel="noreferrer"><img src={mock04} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/uk_onlineretail-dataeng" target="_blank" rel="noreferrer"><h2>UK Online Retail DataEng</h2></a>
                <p>Retail Data Pipeline with aws S3 bucket, Databricks, GCP BigQuery and Looker.</p>
            </div>

            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/cdiscount" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/cdiscount" target="_blank" rel="noreferrer"><h2>Cdiscount : Tracking Sentiment</h2></a>
                <p>This project aims to analyze customer reviews of Cdiscount from February 13, 2024, to February 13, 2025, gathered from Trustpilot. By performing sentiment analysis on these reviews, I aim to uncover trends related to customer satisfaction and delivery issues. The project highlights the growing dissatisfaction with Cdiscount's services and the urgent need for improvements.</p>
            </div>

            <div className="project">
                <a href="https://github.com/ChahiriAbderrahmane/cdiscount_assistant_chatbot" target="_blank" rel="noreferrer"><img src={mock06} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/ChahiriAbderrahmane/cdiscount_assistant_chatbot" target="_blank" rel="noreferrer"><h2>Cdiscount AI Assistant</h2></a>
                <p>The goal is to develop an AI-powered chatbot that interacts with users by providing relevant and professional responses. This chatbot uses data sourced from the official Cdiscount Q&A section to provide accurate and interactive information.</p>
            </div>


            

        </div>
    </div>
    );
}

export default Project;